import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";
import type { AvatarConfig } from "../components/AvatarEditor";

export type AvatarShopItem = { id: string; category: "background"; value: string; name: string; description: string; price: number };
export type AvatarShopState = { balance: number; ownedItemIds: string[]; catalog: AvatarShopItem[] };

const getStateCall = httpsCallable<{ householdId: string }, AvatarShopState>(functions, "getAvatarShopState");
const purchaseCall = httpsCallable<{ householdId: string; itemId: string; requestId: string }, Pick<AvatarShopState, "balance" | "ownedItemIds">>(functions, "purchaseAvatarItem");
const saveCall = httpsCallable<{ householdId: string; avatar: AvatarConfig }, { avatar: AvatarConfig }>(functions, "saveMyAvatar");

export async function getAvatarShopState(householdId: string) { return (await getStateCall({ householdId })).data; }
export async function purchaseAvatarItem(householdId: string, itemId: string) {
  return (await purchaseCall({ householdId, itemId, requestId: crypto.randomUUID() })).data;
}
export async function saveMyAvatar(householdId: string, avatar: AvatarConfig) { return (await saveCall({ householdId, avatar })).data.avatar; }
